function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useContext, useEffect, useState } from 'react';
import { TwoColumnContainerContext } from "nood-comp/src/comp/ui/containers/TwoColumnContainer";
import SearchFilterForm from "nood-comp/src/comp/form/search-filter/SearchFilterForm";
import InfiniteList from "nood-comp/src/comp/data/InfiniteList";
import Pager from "nood-comp/src/comp/data/Pager";
import Button from "nood-comp/src/comp/button/Button";
import { NavLink, useNavigate } from "react-router-dom";
import { useDocumentTitle } from "usehooks-ts";
import { useURLParam } from "nood-comp/src/hooks/useURLParam";
import { msgs } from "nood-comp/src/locale/msgs";
import Icon from "nood-comp/src/comp/ui/feather-icon/Icon";
import SearchFilterTextfield from "nood-comp/src/comp/form/search-filter/SearchFilterTextfield";
import { msg } from "src/app/msg";
import FlexVertical from "nood-comp/src/comp/ui/containers/flex-boxes/FlexVertical";
import Tag from "nood-comp/src/comp/ui/tag/Tag";
import { color } from "nood-comp/src/util/ui/color";
import { date_util } from "nood-comp/src/util/date/DateUtil";
import Row from "nood-comp/src/comp/ui/containers/flex-boxes/Row";
import CloudinaryImg from "nood-comp/src/comp/ui/image-viewer/CloudinaryImg";
import Table from "nood-comp/src/comp/data/table/Table";
import Flex from "nood-comp/src/comp/ui/containers/Flex";
import Text from "nood-comp/src/comp/text/Text";
import { queryStringMod } from "nood-comp/src/util/converters/converters";
import ElapsedTime from "nood-comp/src/util/date/ElapsedTime";
export default function Orgs(props) {
  useDocumentTitle(msg.title(msgs.many(msg.org)));
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    list = _useState2[0],
    set_list = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    filter = _useState4[0],
    set_filter = _useState4[1];
  var _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    xhr_timeout = _useState6[0],
    set_xhr_timeout = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    fetching = _useState8[0],
    set_fetching = _useState8[1];
  var _useState9 = useState(new Pager({
      n: 10
    })),
    _useState0 = _slicedToArray(_useState9, 2),
    pager = _useState0[0],
    set_pager = _useState0[1];
  var id = useURLParam("id");
  useEffect(function () {
    var new_pager = new Pager();
    if ((filter === null || filter === void 0 ? void 0 : filter.trim().length) > 0) {
      var prop_filter = {
        property: "null",
        match_mode: "xx",
        value: filter.trim()
      };
      new_pager.add_or_update_filter(prop_filter);
      new_pager.s = ['~null'];
      set_pager(new_pager);
    }
  }, [filter]);
  return /*#__PURE__*/React.createElement(Table, {
    data_source: "/orgs",
    rowPadding: 5,
    cols: [{
      property: "username",
      label: "Org",
      filterType: "text",
      icon: "tag",
      filterPlaceholder: "Short Name",
      content: function content(obj, idx) {
        return /*#__PURE__*/React.createElement(Flex, {
          gap: 8
        }, /*#__PURE__*/React.createElement(CloudinaryImg, {
          filename: obj.img.filename,
          width: 50,
          height: 50,
          borderRadius: 8,
          popupView: true
        }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(NavLink, {
          to: queryStringMod({
            "do": "view",
            id: obj.id
          })
        }, /*#__PURE__*/React.createElement(FlexVertical, null, /*#__PURE__*/React.createElement(Text, null, obj.display_name), /*#__PURE__*/React.createElement(Text, null, obj.username)))));
      }
    }, {
      label: "",
      width: 50,
      content: function content(obj, idx) {
        return /*#__PURE__*/React.createElement(ElapsedTime, {
          datetime: obj.created
        });
      }
    }]
  });
}
var ContentPane = function ContentPane(props) {
  var twoColContext = useContext(TwoColumnContainerContext);
  var pager = twoColContext.pager;
  var navigate = useNavigate();
  var __row = function __row(obj, idx) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(NavLink, {
      to: "/part?do=view&id=".concat(obj.id)
    }, /*#__PURE__*/React.createElement("span", {
      className: "text-bold"
    }, "CODE")), /*#__PURE__*/React.createElement("br", null));
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    style: {
      padding: "0px"
    }
  }, /*#__PURE__*/React.createElement(InfiniteList, {
    __get_list: function __get_list(list) {
      twoColContext.set_processing(false);
    },
    data_table: {
      cols: [{
        label: 'Username',
        content: function content(o) {
          var _o$logo, _o$tier_$motif, _o$tier_, _o$tier_2, _o$tier_$motif2, _o$tier_3;
          return /*#__PURE__*/React.createElement(Row, {
            gap: 8
          }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(NavLink, {
            to: "?pg=orgs&do=view&id=".concat(o.id)
          }, /*#__PURE__*/React.createElement(CloudinaryImg, {
            filename: (_o$logo = o.logo) === null || _o$logo === void 0 ? void 0 : _o$logo.filename,
            resourceImageSize: "S",
            width: 70,
            height: 70,
            borderRadius: 15
          }))), /*#__PURE__*/React.createElement(FlexVertical, null, /*#__PURE__*/React.createElement(NavLink, {
            to: "?pg=orgs&do=view&id=".concat(o.id)
          }, o.display_name), /*#__PURE__*/React.createElement(Row, {
            gap: 5
          }, /*#__PURE__*/React.createElement(NavLink, {
            to: "?pg=orgs&do=view&id=".concat(o.id)
          }, o.username), /*#__PURE__*/React.createElement(Tag, {
            textColor: color.chooseCorrectForegroundColor({
              backgroundHex: (_o$tier_$motif = (_o$tier_ = o.tier_) === null || _o$tier_ === void 0 ? void 0 : _o$tier_.motif) !== null && _o$tier_$motif !== void 0 ? _o$tier_$motif : '#aaaaaa',
              foregroundHexDark: "#333333",
              foregroundHexLight: "#fefefe"
            }),
            style: {
              padding: "2px 4px",
              borderRadius: "2px",
              color: "#fff",
              textTransform: "uppercase",
              fontSize: "10px"
            },
            value: (_o$tier_2 = o.tier_) === null || _o$tier_2 === void 0 ? void 0 : _o$tier_2.name,
            color: color.appendAlpha((_o$tier_$motif2 = (_o$tier_3 = o.tier_) === null || _o$tier_3 === void 0 ? void 0 : _o$tier_3.motif) !== null && _o$tier_$motif2 !== void 0 ? _o$tier_$motif2 : '#aaaaaa', 60)
          }))));
        }
      }, {
        label: "Campus/System",
        content: function content(org) {
          var _org$campus;
          return /*#__PURE__*/React.createElement(React.Fragment, null, (_org$campus = org.campus) === null || _org$campus === void 0 ? void 0 : _org$campus.short_name);
        }
      }, {
        label: 'Subscription End',
        content: function content(org) {
          return /*#__PURE__*/React.createElement(FlexVertical, {
            gap: 4,
            style: {
              display: "flex-inline"
            }
          }, /*#__PURE__*/React.createElement("div", null, date_util.as_local(org.tier_expiry, 'yyyy-mmm-dd')));
        }
      }, {
        width: 20,
        label: "",
        content: function content(o) {
          return /*#__PURE__*/React.createElement(NavLink, {
            to: "?do=edit&id=".concat(o.id)
          }, /*#__PURE__*/React.createElement(Icon, {
            icon: "edit-2"
          }));
        }
      }]
    },
    pager: pager,
    row: function row(obj, idx) {
      return __row(obj, idx);
    },
    uri: process.env.API + '/orgs'
  })));
};
var SearchPane = function SearchPane(props) {
  var form_ = useContext(TwoColumnContainerContext);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SearchFilterForm, {
    __collect: function __collect(obj) {},
    __submit: function __submit(obj) {
      form_.set_pager(new Pager({
        n: 10
      }).from_form(obj));
    }
  }, /*#__PURE__*/React.createElement(SearchFilterTextfield, {
    name: "username",
    label: 'Username',
    icon: 'tag'
  }), /*#__PURE__*/React.createElement(Button, {
    disabled: form_.processing,
    loading: form_.processing,
    icon: 'search',
    small: true,
    primary: true,
    label: 'Search',
    style: {
      padding: '4px 10px'
    }
  })));
};